import {
  address_documentType_data,
  identity_documentType_data,
} from "./all";
import { nationality_data } from "./all";

/**
 * Update layout — region/zone/woreda are display-only and show the original
 * values from the backend identity DTO (not the static location tree).
 */
const useUpdateDemoLayoutForm = ({ identity }) => {
  const regionEng = identity?.region?.eng || "";
  const regionAmh = identity?.region?.amh || "";
  const zoneEng = identity?.zone?.eng || "";
  const zoneAmh = identity?.zone?.amh || "";
  const woredaEng = identity?.woreda?.eng || "";
  const woredaAmh = identity?.woreda?.amh || "";

  const layout = [
    {
      type: "profile",
    },
    {
      type: "edit",
      title: "demo-data",
      formFields: [
        {
          grid: "col-span-2",
          name: "name",
          label: "Name",
          type: "name",
          required: true,
          disabled: false,
        },
        {
          name: "gender",
          label: "Gender",
          type: "select",
          options: [
            { label: "Male", value: "Male" },
            { label: "Female", value: "Female" },
          ],
          required: true,
          disabled: false,
        },
        {
          name: "gender",
          label: "ጾታ",
          type: "select",
          options: [
            { label: "ወንድ", value: "Male" },
            { label: "ሴት", value: "Female" },
          ],
          required: true,
          disabled: false,
        },
        {
          name: "nationality",
          label: "Nationality",
          type: "select",
          options: nationality_data?.map((item) => ({
            label: item.name,
            value: item.id,
          })),
          required: true,
          disabled: false,
        },
        {
          name: "nationality",
          label: "ዜግነት",
          type: "select",
          options: nationality_data?.map((item) => ({
            label: item.nameamh,
            value: item.id,
          })),
          required: true,
          disabled: false,
        },
        {
          name: "dateOfBirth",
          label: "Date Of Birth",
          type: "text",
          required: true,
          disabled: false,
        },
        {
          name: "dobAmh",
          label: "ትውልድ ቀን",
          type: "text",
          required: true,
          disabled: false,
        },
      ],
    },
    {
      title: "title-location",
      type: "edit",
      formFields: [
        {
          name: "region",
          label: "Region",
          type: "select",
          options: regionEng
            ? [{ label: regionEng, value: regionEng }]
            : [],
          required: true,
        },
        {
          name: "region",
          label: "ክልል",
          type: "select",
          options: regionEng
            ? [{ label: regionAmh || regionEng, value: regionEng }]
            : [],
          required: true,
        },
        {
          name: "zone",
          label: "Zone",
          type: "select",
          options: zoneEng ? [{ label: zoneEng, value: zoneEng }] : [],
          required: true,
        },
        {
          name: "zone",
          label: "ዞን",
          type: "select",
          options: zoneEng
            ? [{ label: zoneAmh || zoneEng, value: zoneEng }]
            : [],
          required: true,
        },
        {
          name: "woreda",
          label: "Woreda",
          type: "select",
          options: woredaEng
            ? [{ label: woredaEng, value: woredaEng }]
            : [],
          required: true,
        },
        {
          name: "woreda",
          label: "ወረዳ",
          type: "select",
          options: woredaEng
            ? [{ label: woredaAmh || woredaEng, value: woredaEng }]
            : [],
          required: true,
        },
        {
          grid: "col-span-2",
          name: "phone",
          label: "Phone Number",
          type: "number",
          required: true,
          disabled: false,
        },
        {
          grid: "col-span-2",
          name: "email",
          label: "Email",
          type: "text",
          required: true,
        },
      ],
    },
    {
      title: "previously-uploaded",
      type: "preview",
    },
    {
      title: "poi",
      type: "document",
      doc_upload_format: "document-upload-format",
      doc_types: {
        POI: {
          doc_type_title: "document-type-upload-poi",
          doc_type: "uploadPoiDocumentType",
          doc_selection: "document-type-selection",
          doc_type_data: identity_documentType_data,
          doc_button_title: "upload-document",
          doc_upload_proof: "poiUploadProof",
        },
      },
    },
    {
      title: "poa",
      type: "document",
      doc_upload_format: "document-upload-format",
      doc_types: {
        POA: {
          doc_type_title: "document-type-upload-poa",
          doc_type: "uploadPoaDocumentType",
          doc_selection: "document-type-selection",
          doc_type_data: address_documentType_data,
          doc_button_title: "upload-document",
          doc_upload_proof: "poaUploadProof",
        },
      },
    },
  ];
  return { layout };
};

export default useUpdateDemoLayoutForm;
